export default __webpack_public_path__ + "static/media/790651356842819584.979e1754.png";